module.exports = __webpack_public_path__ + "img/39.8.TSS.6da872e7.png";